import axios from 'axios'
import router from './../../../router';

export const getTendiks = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-tendiks/" + payload)
            .then((response) => {
                // console.log(response.data);
                commit('SET_TENDIKS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve(true)
            })
            .catch((errors) => {
                resolve(false)
                    // commit('SET_ERRORS_FORM_GURU', errors.data.errors);
            });
    });
}

export const getTendiksPersekolah = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-tendiks-persekolah/" + payload)
            .then((response) => {
                commit('SET_TENDIKS_PERSEKOLAH', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const getTendiksQueuePersekolah = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        commit("SET_OVERLAY", true, { root: true });
        axios
            .get("/api/get-tendiks-queue-persekolah/" + payload)
            .then((response) => {
                commit('SET_TENDIKS_QUEUE_PERSEKOLAH', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail')
            });
    })
}

export const getTendikSolo = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios.get('/api/get-tendik/' + payload).then((response) => {
            resolve(response.data)
            commit("SET_OVERLAY", false, { root: true });
        }).catch(e => {
            reject(e.response.status)
        });
    });
}


export const storeTendik = ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
        commit("SET_OVERLAY", true, { root: true });
        let nama = payload.nama;
        axios.post("/api/tambah-tendik", payload).then((response) => {
            let notif = {
                msg: nama + " Berhasil ditambahkan~",
                type: "create"
            }
            dispatch("getTendiksQueuePersekolah", payload.sekolah_id).then(() => {
                commit("SET_NOTIF", notif, { root: true });
            });
            resolve('success');
        }).catch((e) => {
            if (e.response.data.code == 'SE500') {
                router.push('/app/server-error');
            }
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors);
        });
    })
}

export const updateTendik = ({ commit, dispatch }, payload) => {
    let formData = new FormData();
    if (payload.is_approve) {
        let arr = ['id', 'is_approve', 'pin', 'agama_id', 'status_perkawinan', 'no_telepon', 'alamat_domisili', 'gelar_depan', 'gelar_belakang', 'no_nuptk', 'no_bpjs', 'email', 'golda'];
        for (const [key, value] of Object.entries(payload)) {
            if (arr.includes(key)) {
                formData.append(key, value);
            }
        }
    } else {
        let arr = ['jendik', 'sekolah', 'stapeg', 'agama', 'mutens', 'latest_pangkat', 'latest_berkala', 'is_approve', 'approve_text', 'age', 'pensiun', 'kawin_text', 'nama_gelar', 'age_pensiun', 'ttl', 'jk_text', 'toten', 'created_at', 'updated_at', 'is_admin', 'jensek_id'];
        for (const [key, value] of Object.entries(payload)) {
            if (!arr.includes(key)) {
                formData.append(key, value);
            }
        }
    }

    return new Promise((resolve, reject) => {
        commit("SET_OVERLAY", true, { root: true });
        let nama = payload.nama;
        axios.post("/api/update-tendik", formData).then((response) => {
            let notif = {
                msg: nama + " Berhasil diupdate~",
                type: "update"
            }

            if (payload.is_admin) {
                dispatch("getTendiks", payload.jensek_id).then(() => {
                    commit("SET_NOTIF", notif, { root: true });
                });
            } else if (payload.is_approve) {
                dispatch("getTendiksPersekolah", payload.sekolah_id).then(() => {
                    commit("SET_NOTIF", notif, { root: true });
                });
            } else {
                dispatch("getTendiksQueuePersekolah", payload.sekolah_id).then(() => {
                    commit("SET_NOTIF", notif, { root: true });
                });
            }
            resolve('success');
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors);
        });
    })
}

export const deleteTendik = ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
        commit("SET_OVERLAY", true, { root: true });
        let nama = payload.nama;
        axios.delete("/api/hapus-tendik/" + payload.id).then((response) => {
            let msg = 'Berhasil dihapus~';
            if (response.data.msg == 'batal') msg = 'Promosi dibatalkan.'
            let notif = {
                msg: nama + " " + msg,
                type: "delete"
            }
            dispatch("getTendiksQueuePersekolah", payload.sekolah_id).then(() => {
                commit("SET_NOTIF", notif, { root: true });
            });
            resolve('success');
        }).catch((e) => {
            if (e.response.data.code == 'SE500') {
                router.push('/app/server-error');
                commit("SET_OVERLAY", false, { root: true });
            }
            reject('fail');
        });
    })
}

///////////////////////////

export const updateFotoTendik = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    formData.append("file", payload.file);
    formData.append("tendik_id", payload.tendik_id);
    formData.append("tendik_alias", payload.tendik_alias);

    return new Promise((resolve, reject) => {
        axios.post("/api/update-foto-tendik", formData).then((response) => {
            let notif = {
                msg: "Foto Tendik Berhasil diupdate~",
                type: "update"
            }
            commit("SET_NOTIF", notif, { root: true });
            dispatch("getTendikSolo", payload.tendik_id).then(() => {
                resolve(response)
            });
        }).catch((e) => {
            if (e.response.data.code == 'SE500') {
                router.push('/app/server-error');
            }
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

/////////////////////////////////// paten

export const getPatens = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios.get('/api/get-patens/' + payload).then((response) => {
            resolve(response.data)
            commit("SET_OVERLAY", false, { root: true });
        }).catch(e => {
            console.log(e)
        });
    });
}


export const storePaten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios.post("/api/store-paten", formData).then((response) => {
            let notif = {
                msg: "Pangkat Tendik Berhasil ditambahkan~",
                type: "create"
            }
            commit("SET_NOTIF", notif, { root: true });
            dispatch("getPatens", payload.tendik_id).then((res) => {
                resolve(res);
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const updatePaten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ['status', 'file_pangkat', 'created_at', 'updated_at', 'status_text', 'paone', 'alasan_ditolak'];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios.post("/api/update-paten", formData).then((response) => {
            let notif = {
                msg: "Pangkat Tendik Berhasil ditambahkan~",
                type: "update"
            }
            dispatch("getPatens", payload.tendik_id).then((res) => {
                resolve(res);
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const deletePaten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.patwo.nama_gol + ', ' + payload.patwo.gol;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-paten/" + payload.id).then((response) => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            dispatch("getPatens", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    })
}

/////////////////////////////////////////

export const getBeditens = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios.get('/api/get-beditens/' + payload).then((response) => {
            resolve(response.data)
        }).catch(e => {
            // console.log(e)
        });
    });
}


export const storeBediten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    formData.append("file", payload.file);
    formData.append("tendik_alias", payload.tendik_alias);
    formData.append("tendik_id", payload.tendik_id);
    formData.append("berkas_id", payload.berkas_id);

    return new Promise((resolve, reject) => {
        axios.post("/api/store-bediten", formData).then((response) => {
            let notif = {
                msg: "Berkas Diri Tendik Berhasil ditambahkan~",
                type: "create"
            }
            dispatch("getBeditens", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const updateBediten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    formData.append("id", payload.id);
    formData.append("file", payload.file);
    formData.append("tendik_alias", payload.tendik_alias);
    formData.append("tendik_id", payload.tendik_id);
    formData.append("berkas_id", payload.berkas_id);

    return new Promise((resolve, reject) => {
        axios.post("/api/update-bediten", formData).then((response) => {
            let notif = {
                msg: "Berkas tendik berhasil diupdate~",
                type: "update"
            }
            dispatch("getBeditens", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const deleteBediten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_berkas;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-bediten/" + payload.id).then((response) => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            dispatch("getBeditens", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    })
}

/////////////////////// honor 

export const getRiwayatHonor = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios.get('/api/get-riwayat-honor-tendiks/' + payload).then((response) => {
            resolve(response.data)
        }).catch(e => {

        });
    });
}


export const storeRiwayatHonor = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios.post("/api/store-riwayat-honor-tendik", formData).then((response) => {
            let notif = {
                msg: "Riwayat Pengangkatan Honor/Non PNS Berhasil ditambahkan~",
                type: "create"
            }

            dispatch("getRiwayatHonor", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const updateRiwayatHonor = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ['file_path', 'created_at', 'updated_at'];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios.post("/api/update-riwayat-honor-tendik", formData).then((response) => {
            let notif = {
                msg: "Riwayat Pengangkatan Honor/Non PNS Berhasil diupdate~",
                type: "update"
            }
            dispatch("getRiwayatHonor", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const deleteRiwayatHonor = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.no_sk;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-riwayat-honor-tendik/" + payload.id).then((response) => {
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            dispatch("getRiwayatHonor", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    })
}

/////////////////////////////

export const getMutens = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios.get('/api/get-mutens/' + payload).then((response) => {
            commit('SET_SEMUA_MUTENS', response.data);
            commit("SET_OVERLAY", false, { root: true });
            resolve('ok');
        }).catch(e => {
            reject('fail');
        });
    });
}

export const getMutenPersekolah = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios.get('/api/get-muten-persekolah/' + payload).then((response) => {
            commit('SET_MUTENS_PERSEKOLAH', response.data);
            commit("SET_OVERLAY", false, { root: true });
            resolve('ok');
        }).catch(e => {
            reject('fail');
        });
    });
}

export const getMutenPertendik = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios.get('/api/get-muten-pertendik/' + payload).then((response) => {
            resolve(response.data)
        }).catch(e => {
            reject('fail');
        });
    });
}

export const ajukanMuten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios.post("/api/ajukan-muten", formData).then((response) => {
            let notif = {
                msg: "Mutasi Tendik Berhasil dibuat~",
                type: "update"
            }
            dispatch("getMutenPersekolah", payload.sekolah_id).then((res) => {
                dispatch("getTendiksPersekolah", payload.sekolah_id).then((r) => {
                    resolve(r)
                    commit("SET_NOTIF", notif, { root: true });
                });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const updateMuten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    formData.append("tgl_pengajuan_mutasi", payload.tgl_pengajuan_mutasi);
    formData.append("muten_id", payload.muten_id);
    formData.append("tendik_id", payload.tendik_id);
    formData.append("tendik_alias", payload.tendik_alias);
    formData.append("alasan_mutasi", payload.alasan_mutasi);
    formData.append("file", payload.file);
    formData.append("to", payload.to);

    return new Promise((resolve, reject) => {
        axios.post("/api/update-muten", formData).then(() => {
            let notif = {
                msg: "Mutasi Tendik Berhasil diperbaiki~",
                type: "update"
            }
            dispatch("getMutenPersekolah", payload.sekolah_id).then((res) => {
                commit('SET_MUTENS_PERSEKOLAH', res.data);
                commit("SET_NOTIF", notif, { root: true });
                resolve('ok');
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const approveMuten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_tendik;
    return new Promise((resolve, reject) => {
        axios.post('/api/approve-muten', payload).then((response) => {
            let notif = {
                msg: nama + " telah disetujui~",
                type: "update"
            }
            dispatch("getMutens", payload.jensek_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
            });
        }).catch(e => {
            reject('fail');
        });
    });
}

//////////////////////eduten

export const getEdutens = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios.get('/api/get-edutens/' + payload).then((response) => {
            resolve(response.data)
        }).catch(e => {

        });
    });
}


export const storeEduten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ['edu', 'file_ijazah', 'created_at', 'updated_at'];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }


    return new Promise((resolve, reject) => {
        axios.post("/api/store-eduten", formData).then((response) => {
            let notif = {
                msg: "Riwayat Pendidikan Berhasil ditambahkan~",
                type: "create"
            }
            dispatch("getEdutens", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const updateEduten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ['edu', 'file_ijazah', 'created_at', 'updated_at'];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }

    return new Promise((resolve, reject) => {
        axios.post("/api/update-eduten", formData).then(() => {
            let notif = {
                msg: "Riwayat Pendidikan Berhasil diupdate~",
                type: "update"
            }
            dispatch("getEdutens", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const deleteEduten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.edu.nama
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-eduten/" + payload.id).then(() => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            dispatch("getEdutens", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    })
}

////////////////gabeten

export const getGabetens = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios.get('/api/get-gabetens/' + payload).then((response) => {
            resolve(response.data)
            commit("SET_OVERLAY", false, { root: true });
        }).catch(e => {

        });
    });
}


export const storeGabeten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios.post("/api/store-gabeten", formData).then((response) => {
            let notif = {
                msg: "Gaji Berkala Tendik Berhasil ditambahkan~",
                type: "create"
            }

            dispatch("getGabetens", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const updateGabeten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ['patwo', 'file_berkala', 'created_at', 'updated_at'];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }
    return new Promise((resolve, reject) => {
        axios.post("/api/update-gabeten", formData).then((response) => {
            let notif = {
                msg: "Gaji Berkala Tendik Berhasil diupdate~",
                type: "update"
            }
            dispatch("getGabetens", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const deleteGabeten = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.patwo.nama_gol + ', ' + payload.patwo.gol;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-gabeten/" + payload.id).then(() => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            dispatch("getGabetens", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    })
}

////////////////riwayat pelantikan kepsek

export const getRiwayatKepseks = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        axios.get('/api/get-riwayat-kepseks/' + payload).then((response) => {
            resolve(response.data)
        }).catch(e => {

        });
    });
}


export const storeRiwayatKepsek = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        formData.append(key, value);
    }

    return new Promise((resolve, reject) => {
        axios.post("/api/store-riwayat-kepsek", formData).then((response) => {
            let notif = {
                msg: "Gaji Berkala Tendik Berhasil ditambahkan~",
                type: "create"
            }

            dispatch("getRiwayatKepseks", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const updateRiwayatKepsek = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let formData = new FormData();
    let arr = ['file_path', 'created_at', 'updated_at'];
    for (const [key, value] of Object.entries(payload)) {
        if (!arr.includes(key)) {
            formData.append(key, value);
        }
    }
    return new Promise((resolve, reject) => {
        axios.post("/api/update-riwayat-kepsek", formData).then((response) => {
            let notif = {
                msg: "Riwayat Pelantikan Kepsek Berhasil diupdate~",
                type: "update"
            }
            dispatch("getRiwayatKepseks", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch((e) => {
            commit("SET_OVERLAY", false, { root: true });
            reject(e.response.data.errors)
        });
    })
}

export const deleteRiwayatKepsek = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.no_sk;
    return new Promise((resolve, reject) => {
        axios.delete("/api/delete-riwayat-kepsek/" + payload.id).then(() => {
            commit("SET_OVERLAY", false, { root: true });
            let notif = {
                msg: nama + " Berhasil dihapus~",
                type: "delete"
            }
            dispatch("getRiwayatKepseks", payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        });
    })
}

///////// approve berkas

export const ajukanBerkas = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.post('/api/ajukan-' + payload.route + '/' + payload.id + '/' + payload.to).then(() => {
            let notif = {
                msg: nama + " berhasil diajukan~",
                type: "update"
            }
            dispatch(payload.dispatch, payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch(e => {

        });
    });
}

export const approveBerkas = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        axios.put('/api/approve-berkas-' + payload.route + '/' + payload.id).then((response) => {
            let notif = {
                msg: nama + " berhasil disetujui~",
                type: "update"
            }
            dispatch(payload.dispatch, payload.tendik_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
                commit("SET_OVERLAY", false, { root: true });
            });
        }).catch(e => {

        });
    });
}

export const tolakBerkas = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama;
    return new Promise((resolve, reject) => {
        let notif = {
            msg: nama + " berhasil ditolak~",
            type: "delete"
        }
        dispatch(payload.dispatch, payload.tendik_id).then((res) => {
            resolve(res)
            commit("SET_NOTIF", notif, { root: true });
            commit("SET_OVERLAY", false, { root: true });
        });
    });
}


//////////////////////////////tenkel

export const getTenkelsPersekolah = ({ commit }, sekolahnya) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-tenkels-persekolah/" + sekolahnya)
            .then((response) => {
                commit('SET_TENKELS_PERSEKOLAH', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((e) => {
                reject('fail')
            });
    })
}

export const getSemuaTenkels = ({ commit }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    return new Promise((resolve, reject) => {
        axios
            .get("/api/get-semua-tenkels/" + payload)
            .then((response) => {
                commit('SET_SEMUA_TENKELS', response.data);
                commit("SET_OVERLAY", false, { root: true });
                resolve('ok')
            })
            .catch((errors) => {
                reject('fail');
            });
    })
}

export const approveTenkel = ({ commit, dispatch }, payload) => {
    commit("SET_OVERLAY", true, { root: true });
    let nama = payload.nama_tendik;
    return new Promise((resolve, reject) => {
        axios.put('/api/approve-tenkel/' + payload.tenkel_id).then((response) => {
            let notif = {
                msg: nama + " telah disetujui~",
                type: "update"
            }
            dispatch("getSemuaTenkels", payload.jensek_id).then((res) => {
                resolve(res)
                commit("SET_NOTIF", notif, { root: true });
            });
        }).catch(e => {
            reject('fail');
        });
    });
}